export default __webpack_public_path__ + "static/media/pinterest.62228a06.png";